import { render, staticRenderFns } from "./_relaxgaming.vue?vue&type=template&id=27e4fee2&lang=pug&"
import script from "./_relaxgaming.vue?vue&type=script&lang=js&"
export * from "./_relaxgaming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports